import DetailContractCandidate from './DetailContractCandidate';

export default DetailContractCandidate;
